import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RecoveryAgent } from '../../../models/recoveryagent.model';

export type RecoveryAgentViewModalData = RecoveryAgent;

@Component({
  selector: 'app-recovery-agent-view-modal',
  standalone: false,
  templateUrl: './recovery-agent-view-modal.component.html',
  styleUrl: './recovery-agent-view-modal.component.css',
})
export class RecoveryAgentViewModalComponent {
  constructor(
    public dialogRef: MatDialogRef<RecoveryAgentViewModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RecoveryAgentViewModalData
  ) {}

  onClose(): void {
    this.dialogRef.close();
  }
}
